module.exports = __webpack_public_path__ + "img/fuel.4a103003.svg";